import type { IConfig, TTypeSection } from './models';

export const textConfigs: Record<TTypeSection, IConfig> = {
    section: {
        text: {
            tag: 'div',
            view: 'accent-caps',
            theme: 'dark',
        },
    },
    subSection: {
        text: {
            tag: 'div',
            theme: 'dark',
            view: 'primary-small',
        },
        link: {
            theme: 'blue',
        },
    },
    sectionLink: {
        text: {
            tag: 'div',
            view: 'secondary-small',
        },
        link: {
            theme: 'blue',
        },
    },
};

export const textConfigsMobile: Record<TTypeSection, IConfig> = {
    ...textConfigs,
    section: {
        text: {
            tag: 'div',
            view: 'tagline',
        },
    },
};
